import { Accordion, Hr, Info as InfoComponent } from 'ui/components'
import { InfoProps } from 'ui/components/Info/Info/InfoProps'
import { Col, Row } from 'ui/themes/globalStyles'

import { useCRBIdLicenseContext } from '../../CRBIdLicenseContext'

const Info = (props: InfoProps) => <InfoComponent withoutPaddingBottom {...props} />

export const AddressList = () => {
  const { data } = useCRBIdLicenseContext()
  return (
    <>
      {data?.addresses?.map((address) => (
        <Accordion
          key={address.street}
          title={'Address: ' + address.street}
          bottomPadding="small"
          children={
            <>
              <Row>
                <Col>
                  <Info label="Street Address">{address.street}</Info>
                </Col>
                <Col>
                  <Info label="Room / Suite #">{address.roomOrSuite}</Info>
                </Col>
              </Row>
              <Hr thin />
              <Row>
                <Col>
                  <Info label="PO Box">{address.box}</Info>
                </Col>
                <Col>
                  <Info label="City">{address.city}</Info>
                </Col>
              </Row>
              <Hr thin />
              <Row>
                <Col>
                  <Info label="County">{address.county}</Info>
                </Col>
                <Col>
                  <Info label="State/Province">{address.state}</Info>
                </Col>
              </Row>
              <Hr thin />
              <Row>
                <Col>
                  <Info label="ZIP/Postal Code">{address.postalCode}</Info>
                </Col>
                <Col>
                  <Info label="Country">{address.country}</Info>
                </Col>
              </Row>
            </>
          }
        />
      ))}
    </>
  )
}
